const Logout = () => <div>logout</div>

export default Logout